// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5ba08df9] .el-select--small {\n  width: 490px;\n}\n[data-v-5ba08df9] .el-select-dropdown {\n  width: 490px;\n}\n", ""]);
// Exports
module.exports = exports;
